import { render } from "./ProductClientProfileSkeleton.vue?vue&type=template&id=553f29e7"
import script from "./ProductClientProfileSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductClientProfileSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__